import qs from 'query-string';

export const updateSearch = (location, updates) => {
  const query = qs.parse(location.search);
  const newQuery = {
    ...query,
    ...updates,
  };
  Object.keys(newQuery).forEach(key => (newQuery[key] === null ? delete newQuery[key] : ''));
  const search = qs.stringify(newQuery);
  return search;
};

export const getQuery = (location) => {
  const query = qs.parse(location.search);
  return query;
};
